import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ComplianceCase } from "../../../domain/entities/compliance";
import { type ComplianceDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getCase = createAsyncThunk<
  ComplianceCase,
  { requestId: string },
  { dispatch: ComplianceDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_CASE, async ({ requestId }, { extra }) => {
  return await extra.complianceRepo.getCase(requestId);
});
